import { useTranslation } from 'react-i18next';

export default function Pricing() {
  const { t } = useTranslation();

  const pricingData = [
    {
      categoryKey: 'category1',
      items: [
        { service: '就労ビザ（技術・人文知識・国際業務）', serviceZh: '工作签证（技术・人文知识・国际业务）', price: '80,000円〜' },
        { service: '経営管理ビザ（新規）', serviceZh: '经营管理签证（新规）', price: '150,000円〜' },
        { service: '経営管理ビザ（更新）', serviceZh: '经营管理签证（更新）', price: '80,000円〜' },
        { service: '家族滞在ビザ', serviceZh: '家族滞在签证', price: '60,000円〜' },
        { service: '永住申請', serviceZh: '永住申请', price: '120,000円〜' },
        { service: 'ビザ更新・資格変更', serviceZh: '签证更新・资格变更', price: '60,000円〜' }
      ]
    },
    {
      categoryKey: 'category2',
      items: [
        { service: '株式会社設立', serviceZh: '股份公司设立', price: '100,000円〜' },
        { service: '合同会社設立', serviceZh: '合同公司设立', price: '80,000円〜' },
        { service: '定款認証手続', serviceZh: '章程认证手续', price: '50,000円〜' },
        { service: '会社変更登記', serviceZh: '公司变更登记', price: '40,000円〜' }
      ]
    },
    {
      categoryKey: 'category3',
      items: [
        { service: '建設業許可（新規）', serviceZh: '建设业许可（新规）', price: '150,000円〜' },
        { service: '建設業許可（更新）', serviceZh: '建设业许可（更新）', price: '80,000円〜' },
        { service: '業種追加', serviceZh: '业种追加', price: '100,000円〜' },
        { service: '経営事項変更届', serviceZh: '经营事项变更申报', price: '30,000円〜' }
      ]
    },
    {
      categoryKey: 'category4',
      items: [
        { service: '帰化申請（普通帰化）', serviceZh: '归化申请（普通归化）', price: '200,000円〜' },
        { service: '帰化申請（簡易帰化）', serviceZh: '归化申请（简易归化）', price: '180,000円〜' },
        { service: '書類準備・翻訳', serviceZh: '文件准备・翻译', price: '別途お見積り' }
      ]
    },
    {
      categoryKey: 'category5',
      items: [
        { service: '古物商許可', serviceZh: '古物商许可', price: '60,000円〜' },
        { service: '酒類販売許可', serviceZh: '酒类销售许可', price: '80,000円〜' },
        { service: '運送業許可', serviceZh: '运输业许可', price: '150,000円〜' },
        { service: '風俗営業許可', serviceZh: '风俗营业许可', price: '120,000円〜' }
      ]
    }
  ];

  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  return (
    <section id="pricing" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-teal-500 mb-3 tracking-wider font-medium">PRICING</p>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">{t('pricing')}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {pricingData.map((category, index) => (
            <div key={index} className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-lg transition-shadow">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 pb-4 border-b-2 border-teal-500">
                {t(category.categoryKey)}
              </h3>
              <div className="space-y-4">
                {category.items.map((item, idx) => (
                  <div key={idx} className="flex justify-between items-start gap-4">
                    <span className="text-sm text-slate-700 flex-1">{isZh ? item.serviceZh : item.service}</span>
                    <span className="text-sm font-bold text-teal-600 whitespace-nowrap">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl p-8 md:p-12 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">{t('freeConsultationTitle')}</h3>
            <p className="text-base md:text-lg mb-6 opacity-90">
              {t('freeConsultationDesc')}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <i className="ri-time-line text-4xl mb-3"></i>
                <p className="text-sm font-medium">{t('quickResponse')}</p>
                <p className="text-xs opacity-80 mt-2">{t('quickResponseDesc')}</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <i className="ri-shield-check-line text-4xl mb-3"></i>
                <p className="text-sm font-medium">{t('expertise')}</p>
                <p className="text-xs opacity-80 mt-2">{t('expertiseDesc')}</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <i className="ri-heart-line text-4xl mb-3"></i>
                <p className="text-sm font-medium">{t('carefulSupport')}</p>
                <p className="text-xs opacity-80 mt-2">{t('carefulSupportDesc')}</p>
              </div>
            </div>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-full text-base font-medium hover:bg-slate-50 transition-colors whitespace-nowrap"
            >
              {t('bookFreeConsultation')}
              <i className="ri-calendar-check-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-slate-600">
            {t('note1')}
            <br />
            {t('note2')}
          </p>
        </div>
      </div>
    </section>
  );
}
